export default {
  header: 'Wähle einen Rezeptschritt aus dem Vorlagen',
  submit: '{templateStep} einfügen',
};
